<template>
  <div id="no-data">
    <div class="loading" v-if="loading">
      <van-loading />
    </div>

    <div v-if="!loading && !articleData && this.attachmentArr.length === 0">
      <div class="no-data">
        <img :src="noData" alt="" />
      </div>
      <div class="no-data-font">当前暂无内容~{{ articleData }}</div>
    </div>
  </div>
</template>

<script>
import noData from '@/assets/image/no-data.png';

export default {
  props: ['loading', 'articleData', 'attachmentArr'],
  data() {
    return {
      noData: noData,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';

#no-data {
  margin: calc-width(20vw) 0;
}

.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  // height: calc-width(127vw);

  img {
    width: calc-width(165vw);
    height: calc-width(127vw);
  }
}

.no-data-font {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $time-color;
  margin-top: calc-width(30vw);
}

.loading {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/NoData.vue